import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CTAButtons } from 'components';

function ImportCustomersContainer() {
  const sessionKey = localStorage.getItem('sessionKey');
  const clientCode = localStorage.getItem('clientCode');
  const navigate = useNavigate();

  const buttons = {
    close: { onClick: () => navigate('/setup/import-products') },
    next: {
      onClick: () => navigate('/hardware'),
    },
  };
  return (
    <div className="d-flex flex-fill flex-column">
      <iframe
        style={{
          background: "url('/assets/img/loader.gif') center center no-repeat",
        }}
        className="import-customers-iframe"
        title="Import Customers iFrame"
        src={`https://customer-importer.erply.com/?clientCode=${clientCode}&sessionKey=${sessionKey}`}
      />
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default ImportCustomersContainer;
